module.exports = __webpack_public_path__ + "media/images/top/map_pin-1d6ddb5cc0e73fbcaa94db439a300375.png";